/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'history': {
    width: 22,
    height: 21,
    viewBox: '0 0 22 21',
    data: '<path pid="0" d="M11.8.5c5.523 0 10 4.477 10 10s-4.477 10-10 10l-.29-.004a10.003 10.003 0 0 1-9.136-6.65.5.5 0 0 1 .942-.335 9.003 9.003 0 0 0 8.485 5.989A9 9 0 1 0 2.894 9.197l1.5-1.505a.5.5 0 0 1 .637-.059l.07.058a.5.5 0 0 1 .058.638l-.057.07-2.447 2.454-.01.01a.503.503 0 0 1-.041.035l.05-.045a.504.504 0 0 1-.338.147h-.015l-.033-.001a.505.505 0 0 1-.038-.004L2.3 11a.501.501 0 0 1-.365-.159l-.01-.011a.502.502 0 0 1-.039-.05l-.008-.013L.17 8.06a.5.5 0 0 1 .791-.605l.055.071.902 1.431C2.66 4.167 6.802.5 11.8.5zm0 4.59a.5.5 0 0 1 .492.41l.009.09L12.3 11h3.457a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492l-.09.008h-3.956a.5.5 0 0 1-.492-.41l-.008-.09V5.59a.5.5 0 0 1 .5-.5z" _fill="#969696" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/history.js